/**
 * Copyright (c) 2026 上海安能聚创供应链管理有限公司.
 * All rights reserved.
 * 公司内部代码，未经书面授权，不得以任何形式复制、传播或用于与本项目无关的其他用途。
 */
import {
  oDGoodsWeight,
  oDGoodsWeightTotal,
  odExportCutoffVolume,
} from '@/services/oDgoodsWeightInfo';

import BigNumber from 'bignumber.js';
import Filter from '../Filter';
import { computeWeights } from '@/utils/query';
import { crudRequest } from '@/services/api';
import { getData } from '@/components/report/service';
import moment from 'moment';
import { processObject } from '@/utils/formatUtil';
import { message } from 'antd';

/* eslint-disable no-console */

const paramsForm = {
  startDate: moment().add(-1, 'days').format('YYYY-MM-DD 00:00:00'),
  endDate: moment().format('YYYY-MM-DD 23:59:59'),
  // 总部没有默认值
  centerFilter: '',
  provinceArea: '',
  centerFilterDepart: '',
  provinceAreaDepart: '',
  // 新增字段
  startAreaType: '1',
  endAreaType: '1',
};

export default {
  namespace: 'odgoodsweightinfosr',
  state: {
    oDGoodsWeight: [], // 按照公斤段展示的table列表
    oDGoodsWeightTotal: {}, // 按照公斤段展示的table列表 合计数据
    active: 'departure',
    tableColumnsType: 'product', // 表格展示类型
    tableColumns: [
      {
        value: 'product',
        label: '按产品类型展示',
      },
      {
        value: 'kilogram',
        label: '按公斤段展示',
      },
      {
        value: 'ticket',
        label: '按票数展示',
      },
      {
        value: 'ticketAvgWeight',
        label: '按票均重展示',
      },
    ], // 表格列类型
    searchParams: { ...paramsForm },
    dataList: [],
    totalRow: {},
    totalLength: 0,
    pageSizeNo: 10,
    pageNo: 1,
    activeChange: {
      active: 'arrive',
      searchParams: { ...paramsForm },
      dataList: [],
      totalRow: {},
    },
  },

  effects: {
    // 导出分拨-分拨货量数据（分拨截单口径，仅总部有权限）：统计所有出发分拨-到达分拨，仅按统计日期过滤
    *exportCutoffVolume({ payload, callback }, { call }) {
      try {
        const params = {
          startDate: moment(payload.startDate).format('YYYY-MM-DD 00:00:00'),
          endDate: moment(payload.endDate).format('YYYY-MM-DD 23:59:59'),
        };
        const response = yield call(odExportCutoffVolume, params);
        if (response && response.code === 1) {
          message.success('导出成功');
          callback && callback();
        } else {
          message.error(response?.message || '导出失败');
        }
      } catch (error) {
        message.error(error?.message || '导出失败');
      }
    },
    *getDatas(_, { put, select, call }) {
      try {
        const {
          tableColumnsType,
          pageNo,
          pageSizeNo,
          searchParams: {
            centerFilter,
            provinceArea,
            startDate,
            endDate,
            centerFilterDepart,
            provinceAreaDepart,
            startAreaType,
            originParentSite,
            endAreaType,
            destinationParentSite,
            ...rest
          },
        } = yield select(({ odgoodsweightinfosr }) => odgoodsweightinfosr);
        const ODGoodsWeightQueryVo = {
          startDate: moment(startDate).format('YYYY-MM-DD 00:00:00'), // 时间区间-开始
          endDate: moment(endDate).format('YYYY-MM-DD 23:59:59'), // 时间区间-结束
          originCenter: centerFilter?.name, // 始发分拨
          originCenterCode: centerFilter?.code, // 始发分拨编码
          destinationCenter: centerFilterDepart?.name, // 目的分拨
          destinationCenterCode: centerFilterDepart?.code, // 目的分拨编码
          originProvinceArea: provinceArea?.name, // 始发营运区
          originProvinceAreaCode: provinceArea?.code, // 始发营运区编码
          destinationProvinceArea: provinceAreaDepart?.name, // 目的营运区
          destinationProvinceAreaCode: provinceAreaDepart?.code, // 目的营运区编码
          dataType: 1,
          // 新增的字段（待联调）
          // startAreaType,
          originParentSiteName: originParentSite?.parentsitename,
          originParentSiteCode: originParentSite?.parentsitecode,
          // endAreaType,
          destinationParentSiteName: destinationParentSite?.parentsitename,
          destinationParentSiteCode: destinationParentSite?.parentsitecode,
        };
        const { data: ODGoodsWeightData = [] } = yield call(oDGoodsWeight, {
          ...ODGoodsWeightQueryVo,
          page: pageNo,
          pageSize: pageSizeNo,
        });
        const { data: ODGoodsWeightTotalData = {} } = yield call(
          oDGoodsWeightTotal,
          ODGoodsWeightQueryVo,
        );
        console.log(
          '%c [ ODGoodsWeightData?.rows ]-84',
          'font-size:13px; background:pink; color:#bf2c9f;',
          ODGoodsWeightData?.rows,
        );

        console.log(
          '%c [ ODGoodsWeightTotalData ]-85',
          'font-size:13px; background:pink; color:#bf2c9f;',
          ODGoodsWeightTotalData,
        );
        const _oDGoodsWeight = processObject(ODGoodsWeightData?.rows);
        console.log(
          '%c [ _oDGoodsWeight ]-85',
          'font-size:13px; background:pink; color:#bf2c9f;',
          _oDGoodsWeight?.[0],
        );
        const _ODGoodsWeightTotalData = processObject(ODGoodsWeightTotalData);
        console.log(
          '%c [ _ODGoodsWeightTotalData ]-87',
          'font-size:13px; background:pink; color:#bf2c9f;',
          _ODGoodsWeightTotalData,
        );

        yield put({
          type: 'updateState',
          payload: {
            oDGoodsWeight: _oDGoodsWeight,
            oDGoodsWeightTotal: _ODGoodsWeightTotalData,
            totalLength: ODGoodsWeightData?.total || 0,
          },
        });
      } catch (error) {
        // 错误处理
        console.error(
          'Error occurred while processing ODGoodsWeightData or ODGoodsWeightTotalData:',
          error,
        );
        message.error('数据加载失败，请稍后重试');
        yield put({
          type: 'updateState',
          payload: {
            oDGoodsWeight: {},
            oDGoodsWeightTotal: {},
          },
        });
      }
    },
    *getData(_, { put, select }) {
      crudRequest('/api/route/odgoodsweightinfosr/search'); // 日志
      const {
        searchParams: {
          centerFilter,
          provinceArea,
          startDate,
          endDate,
          centerFilterDepart,
          provinceAreaDepart,
        },
      } = yield select(({ odgoodsweightinfosr }) => odgoodsweightinfosr);
      // if (!centerFilter && !provinceArea && !centerFilterDepart && !provinceAreaDepart) {
      // return message.error("至少选择一个查询条件！")
      // }
      const filter = Filter({
        originCenter: centerFilter?.name,
        originProvinceArea: provinceArea?.name,
        destinationCenter: centerFilterDepart?.name,
        destinationProvinceArea: provinceAreaDepart?.name,
        startDate,
        endDate,
      });

      const reqAll = filter.map((filterItem) => getData(filterItem));
      const dataSource = yield Promise.all(reqAll);
      let dataList = [];
      if (dataSource.length > 0) {
        dataSource[0].forEach((item, i) => {
          if (item.destinationCenter) {
            const originCenter = item.originCenter;
            const destinationCenter = item.destinationCenter;
            const originProvinceArea = item.originProvinceArea;
            const destinationProvinceArea = item.destinationProvinceArea;
            item.originCenter2 = originCenter?.replace(/分拨中心|经营本部|省区|营运区|管理区/g, '');
            item.destinationCenter2 = destinationCenter?.replace(
              /分拨中心|经营本部|省区|营运区|管理区/g,
              '',
            );
            item.originProvinceArea2 = originProvinceArea?.replace(
              /分拨中心|经营本部|省区|营运区|管理区/g,
              '',
            );
            item.originProvinceArea2 = item.originProvinceArea2?.replace(
              /分拨中心|经营本部|省区|营运区|管理区/g,
              '',
            );
            item.destinationProvinceArea2 = destinationProvinceArea?.replace(
              /分拨中心|经营本部|省区|营运区|管理区/g,
              '',
            );
            item.destinationProvinceArea2 = item.destinationProvinceArea2?.replace(
              /分拨中心|经营本部|省区|营运区|管理区/g,
              '',
            );
            item.routePath2 = item.originCenter2 + '-' + item.destinationCenter2;
            const obj = { index: i, ...item, weight0: item.calcWeight };
            dataList.push(obj);
          }
        });

        for (let i = 1; i < dataSource.length; i++) {
          const dsItem = dataSource[i];
          for (let j = 0; j < dataList.length; j++) {
            const firstItem = dataList[j];
            dataList[j][`weight${i}`] = 0;
            dsItem.find((lastItem) => {
              if (
                firstItem.originCenter === lastItem.originCenter &&
                firstItem.destinationCenter === lastItem.destinationCenter
                // && firstItem.originProvinceArea === lastItem.originProvinceArea
              ) {
                dataList[j] = { ...firstItem, [`weight${i}`]: lastItem.calcWeight };
                return true;
              }
              return false;
            });
          }
        }
      }
      const totalRow = { totalRow: '合计', length: dataSource.length - 1 };
      dataList.forEach((item) => {
        for (let i = 0; i < dataSource.length; i++) {
          if (!totalRow[`weight${i}`]) {
            totalRow[`weight${i}`] = 0;
          }
          totalRow[`weight${i}`] = Number.parseFloat(
            new BigNumber(totalRow[`weight${i}`]).plus(item[`weight${i}`]).toString(),
          );
          item[`weight${i}`] = computeWeights(item[`weight${i}`], 2);
        }
      });
      yield put({ type: 'updateState', payload: { dataList, totalRow } });
    },
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
    // eslint-disable-next-line no-unused-vars
    updateActive(state, { payload }) {
      const { activeChange, tableColumnsType, tableColumns, ...states } = state;
      return {
        ...activeChange,
        activeChange: {
          ...states,
          searchParams: { ...states.searchParams },
        },
        tableColumns,
        tableColumnsType,
      };
    },
    updateSearchParams(state, { payload }) {
      return { ...state, searchParams: { ...state.searchParams, ...payload } };
    },
  },
};
